import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  dataTable,
} from 'client/helpers/dataTables';

import SrUserSettingDropdownWithSearchBar from 'client/components/SrUserSettingDropdownWithSearchBar/SrUserSettingDropdownWithSearchBar';
import SrPartnerSection from 'client/components/SrPartnerSection';
import SrDataTablePartnerTentantScreeningListings, {
  getDataTableSettingsFromProps,
} from 'client/components/SrDataTablePartnerTentantScreeningListings';
import { LISTING_SERVICE_TYPE_TENANT_SCREENING } from 'common/listingConstants';
import branch from 'client/core/branch';
import { DATA_TABLE_SOURCE_PARTNER_LISTINGS } from 'common/dataTableConstants';

@branch(() => ({
  currentUser: ['currentUser'],
  totalListings: ['dataTables', DATA_TABLE_SOURCE_PARTNER_LISTINGS],
}))
@dataTable(getDataTableSettingsFromProps)
class SrDataTablePartnerTenantScreeningListingsSection extends Component {
  static propTypes = {
    partner: PropTypes.object.isRequired,
    sinceDate: PropTypes.string,
    apartment: PropTypes.object,
    apartmentBuildingId: PropTypes.array,
    dataTableApiState: PropTypes.object.isRequired,
    dataTableIsFullyLoaded: PropTypes.bool.isRequired,
    totalListings: PropTypes.object,
  }

  render() {
    const {
      partner,
      sinceDate,
      apartment,
      apartmentBuildingId,
      dataTableApiState,
      dataTableIsFullyLoaded,
      totalListings,
    } = this.props;

    if (
      (
        !dataTableApiState.inProgress
        && dataTableIsFullyLoaded
        && !totalListings.items.length
      )
    ) {
      return null;
    }

    return (
      <>
        <SrPartnerSection
          title='Listings Accepting Applications'
          headerRow={
            <div className='partnerDataTableFilterContainer flex' style={{ lineHeight: '40px' }}>
              {partner && partner.markets?.length > 1 && (
                <SrUserSettingDropdownWithSearchBar
                  title='Market'
                  notFoundTitle='No markets found'
                  settingField={`partnerPortal.listingsAcceptingApplications.${partner.slug}_marketIds`}
                  dropdownOptions={partner.markets.map((option) => ({
                    label: option.displayNameFull,
                    value: option.marketId,
                  }))}
                />
              )}
            </div>
          }
        >
          <SrDataTablePartnerTentantScreeningListings
            partner={partner}
            sinceDate={sinceDate}
            apartment={apartment}
            apartmentBuildingId={apartmentBuildingId}
            serviceType={LISTING_SERVICE_TYPE_TENANT_SCREENING}
          />
        </SrPartnerSection>
      </>
    );
  }
}

SrDataTablePartnerTenantScreeningListingsSection.displayName = 'SrDataTablePartnerTenantScreeningListingsSection'; // eslint-disable-line max-len

export default SrDataTablePartnerTenantScreeningListingsSection;
